const STORE_ADDRESS_ON_VIACEP = (state, addressOnViacep) => {
  state.addressOnViacep = addressOnViacep;
};

const STORE_STATES = (state, states) => {
  state.states = states;
};

const STORE_GET_ADDRESS_ON_VIACEP = (state, getAddressOnViacep) => {
  state.getAddressOnViacep = getAddressOnViacep;
};

export default {
  STORE_ADDRESS_ON_VIACEP,
  STORE_STATES,
  STORE_GET_ADDRESS_ON_VIACEP
};
